import { withStyles, Theme } from '@material-ui/core';

export interface ColoredCommonProps {
  colored?: string;
  coloredHover?: string;
}

export const withColoredStyles = withStyles<'root', any, ColoredCommonProps>((theme: Theme) => ({
  root: ({ colored, coloredHover = colored }) =>
    colored
      ? {
          color: theme.palette.getContrastText(colored),
          background: colored,
          '&:hover': {
            backgroundColor: coloredHover,
          },
        }
      : {},
}));
